<template>
  <section class="container">
    <div class="btn-group">
      <el-button
        type="primary"
        class="add-btn"
        @click="routerTo(`/product-add`)">新增</el-button>
    </div>

    <table-pagination
      :config="config"
      :datasource="datasource"
      @change-page="handlerPageChange">
      <!-- <el-table-column sl></el-table-column> -->
      <el-table-column
        slot="filter"
        label="封面"
        align="center">
        <template slot-scope="scope">
          <img
            :src="qiniuDomain + scope.row.product_icon"
            style="max-width: 150px; max-height:100px;">
        </template>
      </el-table-column>
      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        width="285"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-button
              type="success"
              plain
              @click="routerTo(`/product-detail/${scope.row.uuid}`)">详情</el-button>
            <el-button
              type="primary"
              plain
              @click="routerTo(`/product-edit/${scope.row.uuid}`)">编辑</el-button>
            <el-button
              type="danger"
              plain
              @click="handlerDel(scope)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </table-pagination>

    <el-dialog
      :title="dialogType==0? '新增': '编辑'"
      :visible.sync="dialogEdit"
      width="500px">

      <el-form label-width="100px">
        <el-form-item label="标题">
          <el-input v-model="editObject.product_title"/>
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model="editObject.product_son_title"/>
        </el-form-item>
        <el-form-item label="价格">
          <el-input v-model="editObject.product_now_price"/>
        </el-form-item>
        <el-form-item label="原价">
          <el-input v-model="editObject.product_price"/>
        </el-form-item>
        <el-form-item label="权重">
          <el-input v-model="editObject.product_sort"/>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            :action="uploadDomain"
            :data="uploadData"
            :on-success="uploadSuccess"
            :show-file-list="false">
            <img
              v-if="editObject.product_icon"
              :src="qiniuDomain + editObject.product_icon"
              class="avatar">
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
        </el-form-item>
        <el-form-item label="banner">
          <el-upload
            class="upload-demo"
            :action="uploadDomain"
            :data="uploadData"
            :on-success="uploadBannerSuccess"
            :show-file-list="false"
            list-type="picture">
            <el-button
              size="small"
              type="primary">点击上传</el-button>
          </el-upload>
          <img
            v-if="editObject.product_banner"
            :src="qiniuDomain + editObject.product_banner"
            class="banner-img">
        </el-form-item>
        <!-- 多张banner -->
        <!-- <el-form-item>
          <div
            v-for="(item, index) in editObject.banner"
            :key="index"
            class="banner-box">
            <span
              class="icon"
              @click="onRomoveBanner(index)">×</span>
            <img
              :src="qiniuDomain + item.experience_carousel"
              class="banner-img" >
          </div>
        </el-form-item> -->
      </el-form>

      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="dialogEdit = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSaveClick()">确 定</el-button>
      </span>
    </el-dialog>

  </section>
</template>

<script>
import TablePagination from '@/components/table-pagination';
// import Mixin from '@/mixins/get-qiniu'
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  productList, addProduct, editProduct, delProduct,
} from '@/api/product'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      dialogEdit: false,
      dialogType: 0, //  0-新增、1-编辑
      editObject: { //  根据接口来的命名，不是很喜欢---
        product_title: '',
        product_son_title: '',
        product_english_title: '',
        product_english_son_title: '',
        product_icon: '',
        product_sort: '',
        product_banner: '',
        product_price: '',
        product_now_price: '',
        uuid: '',
      },
      config: {
        // pagination: true,
        size: 5,
        fields: [
          {
            prop: 'product_title',
            label: '标题',
          },
          {
            prop: 'product_son_title',
            label: '副标题',
          },
          {
            prop: 'product_english_title',
            label: '英文标题',
          },
          {
            prop: 'product_english_son_title',
            label: '英文副标题',
          },
          {
            prop: 'product_price',
            label: '原价',
          },
          {
            prop: 'product_now_price',
            label: '价格',
          },
          {
            prop: 'product_sort',
            label: '权重',
          },
        ],
      },
      datasource: {
        total: 1,
        data: [],
      },
      pageIndex: 1,
    };
  },

  components: {
    TablePagination,
  },

  created() {
    this.network().getQiniuInfo()
    this.network().productList()
  },
  methods: {
    routerTo(url) {
      this.$router.push({
        path: url,
      })
    },
    // eslint-disable-next-line no-unused-vars
    handlerPageChange(data) {
      this.pageIndex = data.page
      this.network().productList()
    },
    uploadBannerSuccess(res) {
      this.editObject.product_banner = res.hash
    },
    handlerEdit(data) {
      this.dialogType = 1 // 编辑框
      this.editObject.product_title = data.row.product_title
      this.editObject.product_son_title = data.row.product_son_title
      this.editObject.product_sort = data.row.product_sort
      this.editObject.product_icon = data.row.product_icon
      this.editObject.product_banner = data.row.product_banner
      this.editObject.product_price = data.row.product_price
      this.editObject.product_now_price = data.row.product_now_price
      this.editObject.uuid = data.row.uuid
      this.dialogEdit = true
    },
    handlerDel(data) {
      this.network().delProduct(data.row.uuid)
    },
    openAddDialog() {
      this.dialogType = 0
      this.editObject.product_title = ''
      this.editObject.product_son_title = ''
      this.editObject.product_sort = ''
      this.editObject.product_icon = ''
      this.editObject.product_banner = ''
      this.editObject.product_price = ''
      this.editObject.product_now_price = ''
      this.editObject.uuid = ''
      this.dialogEdit = true
    },
    handlerNavigator(scope) {
      this.$router.push({
        path: `/example-management/example-${scope.row.alias}`,
      });
    },
    uploadSuccess(res) {
      this.editObject.product_icon = res.hash
    },
    event() {
      return {
        onSaveClick: () => {
          //  dialogType: 0-新增、1-编辑
          if (this.dialogType === 0) {
            this.network().addProduct()
          } else {
            this.network().editProduct()
          }
        },
      }
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        productList: async () => {
          const { status, data } = await productList({
            page_index: this.pageIndex,
            page_count: this.config.size,
          })
          if (status === 200) {
            this.datasource.total = data.data_count
            this.datasource.data = data.char
          }
        },
        addProduct: async () => {
          const { status } = await addProduct(this.editObject)
          if (status === 200) {
            this.dialogEdit = false
            this.network().productList()
          }
        },
        editProduct: async () => {
          const { status } = await editProduct(this.editObject)
          if (status === 200) {
            this.dialogEdit = false
            this.network().productList()
          }
        },
        delProduct: async (uuid) => {
          const { status } = await delProduct({
            uuid,
          })
          if (status === 200) {
            this.dialogEdit = false
            this.network().productList()
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .banner-img {
    width: 200px;
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/product/list.vue